
/**
 * Archivo con clase base de proveedores de traducciones e implementaciones correspondientes
 */
export interface TranslationProvider {
    buildUrl(
        origin: string,
        target: string,
        text: string
    ): string;

    parseResponse(data: any): string;
}

export class LingvaProvider implements TranslationProvider {

    private baseUrl = 'https://lingva.ml/api/v1/';

    buildUrl(origin: string, target: string, text: string): string {
        return `${this.baseUrl}${origin}/${target}/${encodeURIComponent(text)}`;
    }

    parseResponse(data: any): string {
        return data.translation;
    }

}

export class MyMemoryProvider implements TranslationProvider {

    private baseUrl = 'https://api.mymemory.translated.net/get?q=';

    buildUrl(origin: string, target: string, text: string): string {
        return `${this.baseUrl}${encodeURIComponent(text)}&langpair=${origin}|${target}`;
    }

    parseResponse(data: ResponseTranslationApiMyMemory): string {
        return data.responseData.translatedText;
    }

}

export const getTranslationProvider = (api: 'lingva' | 'mymemory'): TranslationProvider => {
  return api === 'lingva'
    ? new LingvaProvider()
    : new MyMemoryProvider();
}

// modelo de datos de la API de MyMemory
export interface ResponseTranslationApiMyMemory {
  responseData: ResponseDataApiMyMemory;
  quotaFinished: boolean;
  mtLangSupported: null;
  responseDetails: string;
  responseStatus: number;
  responderId: null;
  exception_code: null;
  matches: MatchTranslationMyMemory[];
}

interface MatchTranslationMyMemory {
  id: string;
  segment: string;
  translation: string;
  source: string;
  target: string;
  quality: number | string;
  reference: null;
  'usage-count': number;
  subject: string;
  'created-by': string;
  'last-updated-by': string;
  'create-date': string;
  'last-update-date': string;
  match: number;
  penalty: number;
}

interface ResponseDataApiMyMemory {
  id: string;
  text: string;
  translatedText: string;
  match: number;
}